import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { ColorOptions } from '../../constants';
import { MatIconModule } from '@angular/material/icon';
import { IColorOption } from '../../interfaces';

@Component({
  selector: 'app-color-picker',
  imports: [CommonModule, MatCardModule, MatIconModule],
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColorPickerComponent {
  icon = input<string>();
  previousColor = input<IColorOption | null>(null);
  colorSelected = output<IColorOption>();

  selectedColor = signal<IColorOption | null>(null);
  ColorOptions = ColorOptions;

  selectColor(color: IColorOption): void {
    this.selectedColor.set(color);
    this.colorSelected.emit(color);
  }

  isColorSelected(color: IColorOption): boolean {
    const selected = this.previousColor()
      ? this.previousColor()
      : this.selectedColor();
    return (
      selected?.color === color.color &&
      selected?.background === color.background
    );
  }
}
